<template>
  <div class="space-between-y">
    <input-item label="选项值">
      <el-input v-model="form.value" placeholder="请输入选项值" clearable></el-input>
    </input-item>
    <input-item label="选项描述">
      <el-input v-model="form.description" placeholder="请输入选项描述" clearable></el-input>
    </input-item>
    <input-item label="选项附图">
      <file-upload-v2 :multiple="false" v-model="temp.files"></file-upload-v2>
    </input-item>

    <el-button type="primary" @click="save">保存</el-button>
  </div>
</template>

<script>
import InputItem from "@/components/base/layout/InputItem.vue";
import FileUploadV2 from "@/components/base/FileUploadV2.vue";
import {utils} from "@/util/utils";

export default {
  name: 'SurveyOptionForm',
  components: {
    FileUploadV2,
    InputItem
  },
  props: {
    option: {},
  },

  data() {
    return {
      form: {},
      temp: {
        files: [],
      },
    };
  },

  created() {
    this.form = this.option;

    if (this.form.url) {
      this.temp.files.push({
        url: this.form.url,
      });
    }
  },

  methods: {
    save() {
      let fileUrl = this.temp.files.map(item => {
        return item.url;
      })[0];

      console.log("fileUrl: " + fileUrl);
      this.$emit("save", {
        ...this.form,
        id: this.form.id || utils.random.generateRandomId(),
        url: fileUrl,
      });
    },
  },


};
</script>

<style scoped>
</style>
